import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { LeaderBoardDataProvider } from "../../data-provider/leader-board.dp";
import { Campaign } from "../../models/campaign.model";
import { Division } from "../../models/division.model";
import { Organisation } from "../../models/organisation.model";
import { PermissionCheck } from "../../shared/permission";
import { OrganisationService } from "../../services/organisation.service";
import { TeamColorDataProvider } from "../../data-provider/team-color.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { OrganisationDataProvider } from "../../data-provider/organisation.dp";
import { Utils } from "../../helper/utils.helper";
import * as d3 from "d3";

let OrganisationResultsComponent = {
    selector: "vcOrganisationResults",
    templateUrl: "/angular/components/organisation/result.component.html",
    bindings: {},
    controller: class OrganisationResultsController {
        private defaultStats: { id: string; name: string; icon: string }[] = [
            { id: "canvasses", name: "Walk Interactions", icon: "assignment" },
            { id: "gocanvasses", name: "Go Interactions", icon: "assignment" },
            {
                id: "conversion_denominator_count",
                name: "Counted Attempts",
                icon: "assignment",
            },
            {
                id: "houseoccupants",
                name: "New Contacts Added",
                icon: "location_city",
            },
            { id: "surveys", name: "New Surveys Created", icon: "list" },
            {
                id: "surveyanswers",
                name: "Survey Answers Given",
                icon: "list",
            },
            {
                id: "talkingpoints",
                name: "New Talking Points Created",
                icon: "comment",
            },
            {
                id: "issues",
                name: "Follow-up requests Logged",
                icon: "question_answer",
            },
            {
                id: "issuelogs",
                name: "Follow-up request Logs",
                icon: "question_answer",
            },
            { id: "teams", name: "New Teams Created", icon: "groups" },
            { id: "users", name: "New Users Added", icon: "account_circle" },
        ];
        public disabledDateTemplates: string[] = ["TD"];
        private totals: any = { overall: 0, highest: 0, average: 0 };
        private stats: object = null;
        private selectedItems = [];
        private groupByDivision = false;
        private finishedLoading = false;
        private lineCount = 0;
        private type: { id: string; name: string };
        private totalReception = 0;
        private selectedRangeLabel = "6 Weeks Ago";
        private canvassStatsLoading = true;
        private colors: string[];
        private description: string;
        private colorAux = [];
        public selectedRange: any;
        public customTemplates: any[];
        private selectedItem = null;
        private activeOrganisation: Organisation;
        private campaigns: Campaign[];
        private organisationid: string | null;
        private divisions: Division[];
        private maxSelectableItems: number;
        private chips: boolean;
        private options;
        private chartData;
        private canvassStats?: any;
        public dates: any;
        public combinedTotals: any;

        private $scope: any;
        private __env: any;
        private dialog: DialogUtils;
        private modelsUtils: any;

        private organisationDataProvider: OrganisationDataProvider;
        private campaignDataProvider: CampaignDataProvider;
        private divisionDataProvider: DivisionDataProvider;
        private organisationService: OrganisationService;
        private permissionProvider: PermissionCheck;
        private leaderBoardDataProvider: LeaderBoardDataProvider;

        constructor(
            $scope: any,
            OrganisationDataProvider: OrganisationDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            DivisionDataProvider: DivisionDataProvider,
            PermissionCheck: PermissionCheck,
            LeaderBoardDataProvider: LeaderBoardDataProvider,
            TeamColorDataProvider: TeamColorDataProvider,
            OrganisationService: OrganisationService,
            __env: any,
            DialogUtils: DialogUtils,
            Utils: Utils,
            ModelsUtils: any
        ) {
            this.$scope = $scope;
            this.__env = __env;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;

            this.organisationDataProvider = OrganisationDataProvider;
            this.campaignDataProvider = CampaignDataProvider;
            this.divisionDataProvider = DivisionDataProvider;
            this.organisationService = OrganisationService;
            this.permissionProvider = PermissionCheck;
            this.leaderBoardDataProvider = LeaderBoardDataProvider;

            this.customTemplates =
                this.leaderBoardDataProvider.getCustomDateTemplates();

            Utils.runWootric();

            this.defaultStats[0].name = this.__env.product1 + " Interactions";
            this.defaultStats[1].name = this.__env.product2 + " Interactions";
            this.type = this.defaultStats[0];

            this.colors = TeamColorDataProvider.teamColours;
            this.description = `The global view of data from all your ${this.__env.strings.campaign}s`;

            this.setUpOrganisation();
        }

        $onInit() {
            this.$scope.$watch(
                () => this.selectedRange,
                (newValue: object, oldValue: object) => {
                    if (!this.activeOrganisation) {
                        return;
                    }

                    if (oldValue && newValue !== oldValue) {
                        this.loadStats(
                            this.type,
                            this.selectedRange.dateStart,
                            this.selectedRange.dateEnd
                        );
                    }
                },
                true
            );
        }

        setUpOrganisation(): void {
            this.campaignDataProvider
                .getOrganisations()
                .then((organisation: Organisation) => {
                    this.divisionDataProvider
                        .getAllDivisions()
                        .then((divisions) => {
                            this.activeOrganisation = organisation;
                            this.campaigns = organisation.campaigns;
                            this.organisationid = organisation.oid;
                            if (this.organisationid == "386") {
                                this.disabledDateTemplates = [];
                                this.selectedRange = {
                                    dateStart: new Date(
                                        new Date().setDate(
                                            new Date().getDate() - 7
                                        )
                                    ),
                                    dateEnd: new Date(
                                        new Date().setDate(new Date().getDate())
                                    ),
                                };
                            } else {
                                this.selectedRange = {
                                    dateStart: new Date(
                                        new Date().setDate(
                                            new Date().getDate() - 8
                                        )
                                    ),
                                    dateEnd: new Date(
                                        new Date().setDate(
                                            new Date().getDate() - 1
                                        )
                                    ),
                                };
                            }
                            this.divisions = divisions;
                            this.groupByDivision = divisions.length > 0;
                            this.maxSelectableItems =
                                this.campaigns.length + this.divisions.length;
                            this.loadStats(
                                this.type,
                                this.selectedRange.dateStart,
                                this.selectedRange.dateEnd
                            );
                            this.finishedLoading = true;
                        });
                });
        }

        isSelected(element: any): boolean {
            const type =
                typeof element.id == "undefined" ? "campaign" : "division";
            const id = type == "campaign" ? element.campaignid : element.id;

            return (
                this.selectedItems.filter(
                    (item) =>
                        item.type === type &&
                        (item.id === id || item.campaignid === id)
                ).length === 0
            );
        }

        querySearch(query): [] {
            let unselectedItems: any = [];

            angular.forEach(this.divisions, (division) => {
                division.type = "division";
                division.campaignids = division.campaigns.map((campaign) => {
                    return campaign.campaignid;
                });

                if (this.isSelected(division)) {
                    unselectedItems.push(division);
                }
            });

            angular.forEach(this.campaigns, (campaign) => {
                campaign.type = "campaign";
                campaign.name = campaign.campaignname;
                campaign.color = campaign.campaigncolor;

                if (this.isSelected(campaign)) {
                    unselectedItems.push(campaign);
                }
            });

            // Sort alphabetically
            unselectedItems = unselectedItems.sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return unselectedItems.filter((item) => {
                return (
                    query == "" ||
                    !query ||
                    item.name.toLowerCase().indexOf(query.toLowerCase()) > -1
                );
            });
        }

        getCampaignFromArray(campaignid: string): Campaign {
            if (campaignid !== "ALL") {
                let campaign;
                angular.forEach(this.campaigns, (value) => {
                    if (parseInt(campaignid) == parseInt(value.campaignid)) {
                        if (angular.isUndefined(value.campaigncolor)) {
                            value.campaigncolor = this.selectRandomColor();
                        }
                        campaign = value;
                    }
                });

                return campaign;
            }

            return this.modelsUtils.campaign({
                campaignname: "All Accounts",
                campaigncolor: "#0493AC",
            });
        }

        transformChip(chip): object {
            this.chips = true;
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }
            // Otherwise, create a new one
            return { campaignname: chip, campaignid: "new" };
        }

        getCanvassStatTitle(key: string, stat): string {
            if (typeof stat != "undefined" && stat.type == "division") {
                return this.divisions
                    .filter((d) => d.id == parseInt(key))
                    .shift().name;
            }
            return this.getCampaignFromArray(key).campaignname;
        }

        dateToString(date: Date): string {
            const day = date.getDate();
            const month = date.getMonth() + 1; // Months are zero based
            const year = date.getFullYear();
            return year + "-" + month + "-" + day;
        }

        mapCampaignIds(items): string[] {
            let campaignids = [];

            if (typeof items !== "undefined" && items.length) {
                for (let item of items) {
                    if (item.type === "division") {
                        for (let campaign of item.campaigns) {
                            campaignids.push(campaign.campaignid);
                        }
                    } else {
                        campaignids.push(item.campaignid);
                    }
                }
            }

            return Array.from(new Set(campaignids)); // Removes duplicates
        }

        mergeCanvassStats(
            a,
            b
        ): {
            reception: object;
            status: Array<any>;
            totalreception: number;
            totalstatus: number;
        } {
            let c = {
                reception: {},
                status: [],
                totalreception: 0,
                totalstatus: 0,
            };

            for (let label in a.reception) {
                c.reception[label] =
                    parseInt(a.reception[label]) + parseInt(b.reception[label]);

                c.totalreception += c.reception[label];
            }

            for (let i = 0; i != b.status.length; i++) {
                if (typeof c.status[i] == "undefined") {
                    c.status[i] = {
                        count: 0,
                        label: "",
                    };
                }
                if (typeof a.status[i] != "undefined") {
                    c.status[i].label = a.status[i].label;
                } else {
                    c.status[i].label = b.status[i].label;
                }
                c.status[i].count =
                    parseInt(!a.status[i] ? 0 : a.status[i].count) +
                    parseInt(!b.status[i] ? 0 : b.status[i].count);

                c.totalstatus += c.status[i].count;
            }

            return c;
        }

        belongsToSelectedDivision(campaignid: string): string | null {
            for (let i in this.selectedItems) {
                let item = this.selectedItems[i];

                if (typeof item.campaignids == "undefined") {
                    continue;
                }

                if (item.campaignids.includes(parseInt(campaignid))) {
                    return item.id;
                }
            }

            return null;
        }

        getCampaignById(campaignid: string): Campaign {
            return this.campaigns
                .filter((campaign) => campaign.campaignid == campaignid)
                .shift();
        }

        getCampaignNameById(campaignid: string): string {
            return this.getCampaignById(campaignid).campaignname;
        }

        getDivisionById(divisionid: string): Division {
            return this.divisions
                .filter((division) => division.id == parseInt(divisionid))
                .shift();
        }

        getDivisionNameById(divisionid: string): string {
            return this.getDivisionById(divisionid).name;
        }

        loadStats(type, startDate: Date, endDate: Date) {
            let campaignids = this.mapCampaignIds(this.selectedItems);

            this.organisationDataProvider
                .getStats(
                    this.activeOrganisation,
                    type,
                    this.dateToString(startDate),
                    this.dateToString(endDate),
                    JSON.stringify(campaignids)
                )
                .then((stats) => {
                    this.stats = stats;

                    this.organisationService
                        .canvassStats({
                            startDate: this.dateToString(startDate),
                            endDate: this.dateToString(endDate),
                            campaigns: JSON.stringify(campaignids),
                        })
                        .then((response) => {
                            const json = response["data"];
                            this.canvassStats = {};
                            let canvassStats = json.data;

                            if (campaignids.length == 0) {
                                this.canvassStats = canvassStats; // ALL
                            } else {
                                for (let campaignid in canvassStats) {
                                    let key = "campaign-" + campaignid;

                                    if (!this.groupByDivision) {
                                        this.canvassStats[key] =
                                            canvassStats[campaignid];
                                        this.canvassStats[key].type =
                                            "campaign";
                                        this.canvassStats[key].title =
                                            this.getCampaignNameById(
                                                campaignid
                                            );
                                        continue;
                                    }

                                    const divisionid =
                                        this.belongsToSelectedDivision(
                                            campaignid
                                        );

                                    if (!divisionid) {
                                        this.canvassStats[key] =
                                            canvassStats[campaignid];
                                        this.canvassStats[key].type =
                                            "campaign";
                                        this.canvassStats[key].title =
                                            this.getCampaignNameById(
                                                campaignid
                                            );
                                        continue;
                                    }

                                    key = "division-" + divisionid;

                                    if (
                                        typeof this.canvassStats[key] ==
                                        "undefined"
                                    ) {
                                        this.canvassStats[key] =
                                            canvassStats[campaignid];
                                    } else {
                                        this.canvassStats[key] =
                                            this.mergeCanvassStats(
                                                this.canvassStats[key],
                                                canvassStats[campaignid]
                                            );
                                    }

                                    this.canvassStats[key].type = "division";
                                    this.canvassStats[key].title =
                                        this.getDivisionNameById(divisionid);
                                }
                            }

                            this.canvassStatsLoading = false;
                        });

                    this.totals.overall = 0;
                    this.totals.highest = 0;
                    this.totals.date = null;

                    let i = 0;

                    this.dates = [];
                    this.combinedTotals = [];

                    angular.forEach(this.stats, (account) => {
                        angular.forEach(account, (stat, j) => {
                            if (i === 0) {
                                this.dates.push(stat.date);
                            }

                            this.totals.overall += parseInt(stat.count);

                            if (!this.combinedTotals[j]) {
                                this.combinedTotals[j] = 0;
                            }

                            this.combinedTotals[j] += parseInt(stat.count);

                            if (parseInt(stat.count) > this.totals.highest) {
                                this.totals.highest = parseInt(stat.count);
                                this.totals.date = stat.date;
                            }
                        });

                        i++;
                    });

                    angular.forEach(this.combinedTotals, (dailyTotal, i) => {
                        if (dailyTotal > this.totals.highest) {
                            this.totals.highest = dailyTotal;
                            this.totals.date = this.dates[i];
                        }
                    });

                    this.totals.average =
                        this.totals.overall / this.dates.length;

                    this.drawLineChart();
                });
        }

        drawLineChart(): void {
            let height = 360;

            if (this.lineCount > 0) {
                height += Math.floor(this.lineCount / 4) * 30;
            }

            this.options = {
                chart: {
                    type: "lineChart",
                    height: height,
                    margin: {
                        top: 50,
                        right: 50,
                        bottom: 50,
                        left: 50,
                    },
                    x: (d) => {
                        return d.x;
                    },
                    y: (d) => {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    transitionDuration: 500,
                    dispatch: {
                        stateChange: (e) => {
                            console.log("stateChange");
                        },
                        changeState: (e) => {
                            console.log("changeState");
                        },
                        tooltipShow: (e) => {
                            console.log("tooltipShow");
                        },
                        tooltipHide: (e) => {
                            console.log("tooltipHide");
                        },
                    },
                    xAxis: {
                        axisLabel: "",
                        tickFormat: (d) => {
                            return d3.time.format("%d %b")(
                                new Date(this.dates[d])
                            );
                        },
                    },
                    yAxis: {
                        axisLabel: "",
                        tickFormat: (d) => {
                            return d3.format(".")(d);
                        },
                    },
                    showMinMax: true,
                },
                title: {
                    enable: false,
                    text: "Statistic line chart",
                },
                subtitle: {
                    enable: false,
                    text: "",
                    css: {
                        "text-align": "center",
                        margin: "10px 13px 0px 7px",
                    },
                },
                caption: {
                    enable: false,
                    html: "<p><h3><span></span></h3></p>",
                    css: {
                        "text-align": "justify",
                        "margin-left": "54px",
                    },
                },
            };

            this.chartData = this.generateData();
        }

        mergeGraphPoints(a, b): object {
            let c = {
                count: 0,
                date: "1970-01-01",
            };

            if (a.date !== b.date) {
                return a;
            }

            c.count = parseInt(a.count) + parseInt(b.count);
            c.date = b.date;

            return c;
        }

        mergeGraphLines(a: any, b: any): any[] {
            let line = [];
            for (let i in a) {
                line.push(this.mergeGraphPoints(a[i], b[i]));
            }
            return line;
        }

        generateData(): any[] {
            let stats = {};

            for (let campaignid in this.stats) {
                if (campaignid == "ALL") {
                    stats["ALL"] = this.stats[campaignid];
                    break;
                }

                let current = this.stats[campaignid];
                let key = "campaign-" + campaignid;

                const divisionid = this.belongsToSelectedDivision(campaignid);

                if (!divisionid || !this.groupByDivision) {
                    stats[key] = this.stats[campaignid];
                } else {
                    key = "division-" + divisionid;

                    if (typeof stats[key] == "undefined") {
                        stats[key] = current;
                    } else {
                        stats[key] = this.mergeGraphLines(stats[key], current);
                    }
                }
            }

            const lines = [];
            angular.forEach(stats, (value: any, key) => {
                if (typeof value == "undefined") {
                    return;
                }

                const total = [];

                value.forEach((item, i) => {
                    total.push({ x: i, y: parseInt(item.count), series: key });
                });

                const meta = this.getLineMeta(key);

                lines.push({
                    values: total,
                    key: meta["name"],
                    color: meta["color"],
                    strokeWidth: 2,
                    area: this.draw(key),
                });
            });

            this.lineCount = lines.length;

            return lines;
        }

        getLineMeta(key): object {
            if (key == "ALL") {
                return {
                    name: "All Sub-Accounts",
                    color: "#333",
                };
            }

            const [type, id] = key.split("-");

            if (type == "campaign") {
                let campaign = this.getCampaignById(id);

                return {
                    name: campaign.campaignname,
                    color: campaign.campaigncolor,
                };
            }

            let division = this.getDivisionById(id);

            return {
                name: division.name,
                color: division.color,
            };
        }

        ok(): void {
            this.loadStats(
                this.type,
                this.selectedRange.dateStart,
                this.selectedRange.dateEnd
            );
        }

        clearChips(): void {
            this.selectedItems = [];
            this.selectedItem = null;
            this.loadStats(
                this.type,
                this.selectedRange.dateStart,
                this.selectedRange.dateEnd
            );
        }

        selectRandomColor(): string {
            let notPickedColors = this.colors.filter(
                (color) => this.colorAux.indexOf(color) == -1
            );
            let rand = Math.floor(Math.random() * notPickedColors.length - 1);

            return notPickedColors[rand];
        }

        draw(key: string): boolean {
            return key === "ALL";
        }

        onToggleGroupByDivision(): void {
            this.loadStats(
                this.type,
                this.selectedRange.dateStart,
                this.selectedRange.dateEnd
            );
        }

        downloadCanvasses(ev: object): void {
            this.dialog.show({
                component: "vc-organisation-result-export",
                targetEvent: ev,
                scope: this.$scope,
                locals: {
                    survey: null,
                },
                size: "large",
                ariaLabel: "Export Data",
            });
        }

        getDateAnalyticsCalculated(): Date {
            let countBackDays: number = 1;
            if (this.organisationid == "386") {
                countBackDays = 0;
            }
            return ((d) => new Date(d.setDate(d.getDate() - countBackDays)))(
                new Date()
            );
        }

        isDisabledDateTemplate(date: Date): boolean {
            return date > this.getDateAnalyticsCalculated();
        }

        itemsContainDivision(items: any[]): boolean {
            for (let item of items) {
                if (typeof item.campaignids != "undefined") {
                    return true;
                }
            }
            return false;
        }
    },
};

angular
    .module("organisation")
    .component(
        OrganisationResultsComponent.selector,
        OrganisationResultsComponent
    );
